import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useWithdraws } from "../../store/useWithdraws";
import { Tooltip } from "@material-tailwind/react";
import { useAuth } from "../../store/useAuth";

export const WithdrawTable = () => {
  /** Hooks */
  const { allWithdraws, refundWithdraw } = useWithdraws();
  const { user } = useAuth();
  const navigate = useNavigate();
  const isStoreAdmin = (user: unknown) =>
    typeof user === "object" &&
    user !== null &&
    "user_role" in user &&
    (user as { user_role?: number }).user_role === 5;

  const getStatusColor = (status?: "CREATED" | "REDEEMED" | "EXPIRED" | "REFUNDED") => {
    switch (status) {
      case "CREATED":
        return "text-blue-700";
      case "REDEEMED":
        return "text-green-700";
      case "EXPIRED":
        return "text-red-700";
      case "REFUNDED":
        return "text-gray-500";
      default:
        return "text-dark";
    }
  };

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              User
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Amount
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Type
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Store Admin
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Status
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Date
            </th>
            {[1, 7].includes(Number(user?.user_role)) ? (
              <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4 text-right">
                Actions
              </th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {allWithdraws?.length
            ? allWithdraws.map((withdraw) => (
                <tr
                  key={withdraw?._id}
                  className="bg-white hover:bg-gray-100 cursor-pointer transition ease-linear border-b"
                  onClick={() => {
                    // @ts-ignore
                    if (withdraw?.user?._id) {
                      // @ts-ignore
                      navigate(`/edit-user/${withdraw.user._id}`);
                    }
                  }}
                >
                  <td className="px-2 sm:px-6 py-1 sm:py-4 whitespace-nowrap">
                    {/* @ts-ignore */}
                    {withdraw?.user?.first_name} {withdraw?.user?.last_name}
                  </td>
                  <td className="px-2 sm:px-6 py-1 sm:py-4">
                    {new Intl.NumberFormat("nl-NL", {
                      style: "currency",
                      currency: "EUR",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(withdraw?.amount ? withdraw?.amount / 100 : 0)}
                  </td>

                  {withdraw?.isDonation ? (
                    <td className="px-2 sm:px-6 py-1 sm:py-4">
                      {withdraw?.status === "REDEEMED" && (
                        <span className="text-purple-700">Donation</span>
                      )}
                    </td>
                  ) : (
                    <td className="px-2 sm:px-6 py-1 sm:py-4">
                      <span className="text-teal-700">Withdraw</span>
                    </td>
                  )}
                  <td className="px-2 sm:px-6 py-1 sm:py-4">
                    {isStoreAdmin(withdraw?.user) ? "Yes" : "No"}
                  </td>
                  <td className="px-2 sm:px-6 py-1 sm:py-4">
                    <span className={getStatusColor(withdraw?.status as any)}>
                      {withdraw?.status}
                    </span>
                  </td>
                  <td className="px-2 sm:px-6 py-1 sm:py-4">
                    {dayjs(withdraw?.createdAt).fromNow()}
                  </td>
                  {Number(user?.user_role) === 7 &&
                  !withdraw?.isDonation &&
                  (withdraw?.status === "CREATED" || withdraw?.status === "EXPIRED") ? (
                    <td
                      className="px-2 sm:px-6 py-1 sm:py-4 text-right cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        const confirmRefund = window.confirm(
                          "Are you sure you want to refund this withdraw?"
                        );
                        if (confirmRefund) {
                          refundWithdraw(withdraw?._id);
                        }
                      }}
                    >
                      <Tooltip content="Refund">
                        <img
                          alt="refund"
                          src={require("../../assets/icons/tables/refund-icon.png")}
                          className="w-5 h-5 inline-block"
                        />
                      </Tooltip>
                    </td>
                  ) : [1, 7].includes(Number(user?.user_role)) ? (
                    <td className="px-2 sm:px-6 py-1 sm:py-4" />
                  ) : null}
                </tr>
              ))
            : null}
        </tbody>
      </table>
    </div>
  );
};
